<template>
  <div id="financial_center">
    <div class="financial_center__inner">
      <div class="tabbar">
        <div :class="item.path===selectItem?'isAcitve':''" v-for="(item,index) in tabbarItem" :key="index" @click="clickItem(item,index)">
          {{item.label}}
        </div>
      </div>
      <div class="financial_center__content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
  },
  components: {

  },
  data () {
    return {
      selectItem:this.$route.path,
      tabbarItem:[
        {label:'充值',path:'/personalCenter/financialCenter'},
        {label:'提现',path:'/personalCenter/financialCenter/withdraw'},
        {label:'提现记录',path:'/personalCenter/financialCenter/withdrawRecord'},
        {label:'收支明细',path:'/personalCenter/financialCenter/moneyDetails'},
      ],
    }
  },
  methods: {
    clickItem(item, index) {
      if(this.$route.path !== item.path){
        this.selectItem = item.path
        this.$router.push({
          path:item.path
        });
      }

    },
  },
  mounted () {

  },
  watch: {

  },
  computed: {

  }
}
</script>
<style lang='less' scoped>
#financial_center{
  padding: 20px;
  display: flex;
  flex-direction: column;

  *,
  *:before,
  *:after{
    box-sizing: border-box;
  }

  .financial_center__inner{
    min-height: 620px;
    display: flex;
    flex-direction: column;
    color: var(--text-main, #111827);
  }

  .tabbar{
    min-height: 40px;
    padding: 4px 0 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    background: transparent;
    border: none;
    border-radius: 0;
    overflow: visible;

    div{
      position: relative;
      min-width: 88px;
      height: 34px;
      padding: 0 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 20px;
      cursor: pointer;
      transition: color .2s ease, background .2s ease, box-shadow .2s ease;
    }

    div:hover{
      color: var(--text-main, #1A1D24);
      background: var(--bg-tag, #F0EDE8);
    }

    .isAcitve{
      position: relative;
      color: #FFFFFF;
      font-weight: 500;
      background: transparent;
      box-shadow: none;
    }

    .isAcitve::before{
      content: "";
      position: absolute;
      inset: 0;
      z-index: -1;
      border-radius: 4px;
      background: var(--bg-dark, #1A1D24);
      transform: skewX(-12deg);
    }

    .isAcitve::after{
      content: "";
      position: absolute;
      left: 16px;
      right: 16px;
      bottom: -8px;
      height: 3px;
      border-radius: 2px;
      background: var(--primary, #FF5A1F);
    }

    .isAcitve:hover{
      color: #FFFFFF;
      background: transparent;
      box-shadow: none;
    }

    .isAcitve:hover::before{
      background: var(--bg-dark, #1A1D24);
    }

    div:last-of-type{
      margin: 0;
    }
  }

  .financial_center__content{
    min-height: 540px;
    margin-top: 18px;

    /deep/.developing-state,
    /deep/.no_data{
      min-height: 520px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      background: var(--bg-card, #FFFFFF);
    }

    /deep/.developing-state{
      padding: 0 24px;
    }

    /deep/.no_data{
      padding: 0 24px;

      img{
        width: auto;
        max-width: 196px;
        height: auto;
        max-height: 151px;
        object-fit: contain;
      }
    }
  }
}
</style>
